import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { brandBlue } from '../../styles/palette'

const SIDEBAR_BG = brandBlue.dark
const SIDEBAR_ACTIVE = brandBlue.darkHover
const SIDEBAR_TEXT = '#f1f5f9'
const SIDEBAR_TEXT_ACTIVE = '#f1f5f9'
const SIDEBAR_SECTION = '#f1f5f9'

export const Root = styled(Box)<{ $open: boolean }>`
  width: ${({ $open }) => ($open ? '240px' : '64px')};
  height: 100vh;
  position: sticky;
  top: 0;
  background-color: ${SIDEBAR_BG};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.2s ease;
  overflow: hidden;
`

export const Header = styled(Box)`
  height: 64px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const LogoBadge = styled(Box)`
  width: 32px;
  height: 32px;
  background-color: ${SIDEBAR_ACTIVE};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LogoLetter = styled(Typography)`
  && {
    color: #ffffff;
    font-weight: 700;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    display: block;
  }
`

export const LogoTitle = styled(Typography)`
  && {
    color: ${SIDEBAR_TEXT_ACTIVE};
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 1px;
  }
`

export const RoleBadge = styled(Typography)`
  && {
    margin-left: auto;
    background-color: ${SIDEBAR_ACTIVE};
    color: #f1f5f9;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
  }
`

export const SidebarDivider = styled(Divider)`
  && {
    border-color: #1e293b;
  }
`

export const Groups = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.2s ease;

  &:hover {
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
  }
`

export const GroupBlock = styled(Box)`
  margin-bottom: 4px;
`

export const GroupTitle = styled(Typography)`
  && {
    padding: 8px 24px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${SIDEBAR_SECTION};
  }
`

export const LinkReset = styled(NavLink)`
  text-decoration: none;
`

export const ItemRow = styled(Box)<{ $active: boolean; $open: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px ${({ $open }) => ($open ? '24px' : '0')};
  margin: 0 8px;
  border-radius: 6px;
  justify-content: ${({ $open }) => ($open ? 'flex-start' : 'center')};
  background-color: ${({ $active }) => ($active ? SIDEBAR_ACTIVE : 'transparent')};
  color: ${({ $active }) => ($active ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT)};
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background-color: ${SIDEBAR_ACTIVE};
    color: ${SIDEBAR_TEXT_ACTIVE};
  }
`

export const ItemLabel = styled(Typography)<{ $active: boolean }>`
  && {
    font-size: 13px;
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
    flex: 1;
  }
`

export const ItemCount = styled(Box)`
  background-color: #3b82f6;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
`

export const Footer = styled(Box)`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const UserAvatar = styled(Avatar)`
  && {
    width: 32px;
    height: 32px;
    background-color: #3b82f6;
    font-size: 13px;
    font-weight: 700;
  }
`

export const UserText = styled(Box)`
  overflow: hidden;
`

export const UserName = styled(Typography)`
  && {
    color: ${SIDEBAR_TEXT_ACTIVE};
    font-size: 13px;
    font-weight: 600;
  }
`

export const UserEmail = styled(Typography)`
  && {
    color: ${SIDEBAR_TEXT};
    font-size: 11px;
  }
`
